/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/header/header-cell.component';
const styles_DataTableHeaderCellComponent:any[] = ([] as any[]);
export const RenderType_DataTableHeaderCellComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableHeaderCellComponent,data:{}});
function View_DataTableHeaderCellComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'label',[['class',
      'datatable-checkbox']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),0,'input',[['type','checkbox']],[[8,'checked',0]],
      [[(null as any),'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.select.emit(!_co.allRowsSelected)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.allRowsSelected;
        _ck(_v,2,0,currVal_0);
      });
}
function View_DataTableHeaderCellComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'span',[['class',
      'datatable-header-cell-wrapper']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','datatable-header-cell-label draggable']],
          [[8,'innerHTML',1]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onSort()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.name;
    _ck(_v,2,0,currVal_0);
  });
}
function View_DataTableHeaderCellComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableHeaderCellComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DataTableHeaderCellComponent_4)),i0.ɵdid(540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutletContext:[0,'ngTemplateOutletContext'],
          ngTemplateOutlet:[1,'ngTemplateOutlet']},(null as any)),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.cellContext;
    const currVal_1:any = _co.column.headerTemplate;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DataTableHeaderCellComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),13,'div',[['class','datatable-header-cell-template-wrap']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DataTableHeaderCellComponent_1)),i0.ɵdid(16384,(null as any),0,i1.NgIf,
      [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_DataTableHeaderCellComponent_2)),i0.ɵdid(16384,
      (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableHeaderCellComponent_3)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),[[8,'className',
              0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.DataTableHeaderCellComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onSort()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:i2.DataTableHeaderCellComponent = _v.component;
        const currVal_0:any = _co.isCheckboxable;
        _ck(_v,4,0,currVal_0);
        const currVal_1:boolean = !_co.column.headerTemplate;
        _ck(_v,7,0,currVal_1);
        const currVal_2:any = _co.column.headerTemplate;
        _ck(_v,10,0,currVal_2);
      },(_ck,_v) => {
        var _co:i2.DataTableHeaderCellComponent = _v.component;
        const currVal_3:any = _co.sortClass;
        _ck(_v,12,0,currVal_3);
      });
}
export function View_DataTableHeaderCellComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-header-cell',
      [['class','datatable-header-cell']],[[4,'height','px'],[8,'className',0],[1,
          'title',0],[4,'minWidth','px'],[4,'maxWidth','px'],[4,'width','px']],[[(null as any),
          'contextmenu']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableHeaderCellComponent_0,RenderType_DataTableHeaderCellComponent)),
      i0.ɵdid(49152,(null as any),0,i2.DataTableHeaderCellComponent,[i0.ChangeDetectorRef],
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).headerHeight;
    const currVal_1:any = i0.ɵnov(_v,1).columnCssClasses;
    const currVal_2:any = i0.ɵnov(_v,1).name;
    const currVal_3:any = i0.ɵnov(_v,1).minWidth;
    const currVal_4:any = i0.ɵnov(_v,1).maxWidth;
    const currVal_5:any = i0.ɵnov(_v,1).width;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export const DataTableHeaderCellComponentNgFactory:i0.ComponentFactory<i2.DataTableHeaderCellComponent> = i0.ɵccf('datatable-header-cell',
    i2.DataTableHeaderCellComponent,View_DataTableHeaderCellComponent_Host_0,{sortType:'sortType',
        sortAscendingIcon:'sortAscendingIcon',sortDescendingIcon:'sortDescendingIcon',
        allRowsSelected:'allRowsSelected',selectionType:'selectionType',column:'column',
        headerHeight:'headerHeight',sorts:'sorts'},{sort:'sort',select:'select',columnContextmenu:'columnContextmenu'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/node_modules/@swimlane/ngx-datatable/release/components/header/header-cell.component.ngfactory.ts